export function getCameraIds() {
    return new Promise((resolve, reject) => {
        navigator.mediaDevices.enumerateDevices()
            .then(function (devices) {
                let deviceList = [];
                devices.forEach(function (device) {
                    if (device.kind === "videoinput") deviceList.push({ cameraId: device.deviceId, label: device.label })
                });
                resolve(deviceList);
            })
            .catch(function (err) {
                console.log(err.name + ": " + err.message);
            });
    })
}